module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid41_980x822.7de0b36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid41_980x822.jpg
// module id = rsQC
// module chunks = 0